export const hasDriverInfo = (driver: server.dto.Driver): boolean =>
  Boolean(driver.name || driver.mobile || driver.email || driver.vehicle);
